(function () {
  'use strict';

  angular
    .module('uwAgenda.settings.aiagent')
    .controller(
      'TranscriptionContentModalController',
      ['$uibModalInstance', 'TranscriptionService', 'transcription', 'hideMarkAsReadButton', TranscriptionContentModalControllerFn]);

  function TranscriptionContentModalControllerFn($uibModalInstance, TranscriptionService, transcription, hideMarkAsReadButton) {
    const vm = this;
    vm.transcription = transcription;
    vm.hideMarkAsReadButton = hideMarkAsReadButton;
    
    let data;
    try {
      data = JSON.parse(transcription.content);
    } catch (e) {
      console.log('error parsing transcription:', e);
      data = transcription.content;
    }
    
    vm.transcriptionData = data;
    
    vm.cancel = function () {
      $uibModalInstance.dismiss();
    };
    
    vm.setAsRead = function () {
      TranscriptionService.setAsRead(vm.transcription.id).then(r => {
        vm.transcription.isRead = true;
      });
      
      $uibModalInstance.dismiss();
    }
  }
})();